import request from '@/utils/request' 
let baseUrl = "https://api.qilianxin.cn"
// let baseUrl = "http://192.168.8.182:8080"
//省
export function getProvinceList() {
    return request({
        url: baseUrl + '/getProvinceList',
        method: 'get',
    })
}
//市
export function getCityList(query) {
    return request({
        url: baseUrl + '/getCityList?provinceCode=' + query,
        method: 'get',
    })
}

//县
export function getAreaList(query) {
    return request({
        url: baseUrl + '/getAreaList?cityCode=' + query,
        method: 'get',
    })
}

//新增
export function consultAdd(query) {
    return request({
        url: baseUrl + '/enterprise/consult',
        method: 'post',
        data: query
    })
}

//政策列表
export function policyList(query) {
  
    return request({
        url: baseUrl + '/system/policy/list',
        method: 'get',
        params: query
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js